import { render, staticRenderFns } from "./SeveralSuppliersSection.vue?vue&type=template&id=00fc181f&"
import script from "./SeveralSuppliersSection.vue?vue&type=script&lang=js&"
export * from "./SeveralSuppliersSection.vue?vue&type=script&lang=js&"
import style0 from "./SeveralSuppliersSection.vue?vue&type=style&index=0&id=00fc181f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports